<template>
  <BaseDialog
    :showDialog="showDialog"
    :close="closeDialog"
    headline="AI Title Assistant"
    maxDialogWidth="600"
    maxCardHeight="520"
    :alvqa="alvqa + '-dialog-title-assist'"
  >
    <template v-slot:dialogText>
      <v-container fluid>
        <v-row>
          <v-col cols="12">
            <div class="font-weight-medium mb-1">{{ $t('lang_PUBLISHING_WORKS_CAPTION_DOMESTIC_WORK_TITLE') }}</div>
            <div class="mb-2">{{ domesticTitle }}</div>

            <div class="mt-6 font-weight-medium">{{ $t('lang_GENERIC_CAPTION_SELECT_FROM_AI_SUGGESTIONS') }}</div>
            <BaseEditPageDropdown
              :context="'WorksTitleAssistDialog'"
              field="TitleAssistSelection"
              :items="titleAssistOptionsDropdown"
              :label="loading ? $t('lang_GENERIC_CAPTION_LOADING') : $t('lang_GENERIC_CAPTION_PLEASE_SELECT')"
              :selection="true"
              :withMargin="false"
              :alvqa="alvqa + '-dropdown-title-assist'"
              :disabled="loading"
              :additionalFunction="onDropdownSelect"
            />

            <div class="font-weight-medium mt-3">{{ $t('lang_PUBLISHING_WORKS_CAPTION_INTERNATIONAL_WORK_TITLE') }}</div>
            <BaseEditPageTextField
              :context="'WorksTitleAssistDialog'"
              field="TitleAssistDraft"
              :withMargin="false"
              :alvqa="alvqa + '-dialog-title-assist-edit'"
              :clearable="true"
              :additionalFunction="onDraftInput"
            />

            <v-row no-gutters>
              <v-col cols="12">
                <BaseCheckbox
                  :context="'WorksTitleAssistDialog'"
                  :label="$t('lang_GENERIC_CAPTION_AUTO_CAPITALIZE')"
                  :valueOuter="'autoCapitalize'"
                  :alvqa="alvqa + '-dialog-title-assist-autocap'"
                  :changeFunction="onAutoCapChange"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-slot:dialogActions>
      <v-container fluid>
        <v-row>
          <v-spacer />
          <v-col class="text-right">
            <BaseButton
              label="lang_GENERIC_CAPTION_APPLY"
              :alvqa="alvqa + '-dialog-title-assist-apply'"
              @click="$emit('apply')"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </BaseDialog>
  </template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseCheckbox from '@/components/_base/BaseCheckbox'

export default {
  name: 'WorksTitleAssistDialog',
  props: { alvqa: { type: String, default: '' } },
  components: { BaseDialog, BaseButton, BaseEditPageTextField, BaseEditPageDropdown, BaseCheckbox },
  data() {
    return { context: 'Work' }
  },
  computed: {
    showDialog: {
      get() { return this.$store.getters.getWorksTitleAssistDialog },
      set(v) { this.$store.commit('setWorksTitleAssistDialog', v) }
    },
    loading() { return this.$store.getters.getWorksTitleAssistLoading },
    domesticTitle() { return this.$store.getters.getWorkDetailsDomesticTitle },
    titleAssistOptions() {
      const s = this.$store.getters.getWorksTitleAssistSuggestions || {}
      const list = []
      if (Array.isArray(s.literal)) list.push.apply(list, s.literal)
      if (s.romaji) list.push(s.romaji)
      if (Array.isArray(s.transcreation)) list.push.apply(list, s.transcreation)
      const seen = {}
      const uniq = []
      for (let v of list) {
        if (!v) continue
        const key = String(v).toLowerCase().trim()
        if (!seen[key]) { seen[key] = true; uniq.push({ text: String(v).trim() }) }
      }
      return uniq
    },
    titleAssistOptionsDropdown() {
      return this.titleAssistOptions.map(o => ({ text: o.text, value: o.text }))
    },
  },
  methods: {
    toUpperAll(str) {
      if (str === null || str === undefined) return str
      return String(str).toUpperCase()
    },
    closeDialog() {
      this.resetTitleAssistState()
      this.showDialog = false
    },
    onDropdownSelect(val) {
      const value = val && val.value !== undefined ? val.value : val
      if (value) {
        const auto = this.$store.getters.getWorksTitleAssistDialogCheckbox
        const isOn = Array.isArray(auto) && auto.indexOf('autoCapitalize') !== -1
        const transformed = isOn ? this.toUpperAll(value) : value
        this.$store.commit('setWorksTitleAssistDialogDetailsTitleAssistSelection', value)
        this.$store.commit('setWorksTitleAssistDialogDetailsTitleAssistDraft', transformed)
      }
    },
    onDraftInput() {
      const auto = this.$store.getters.getWorksTitleAssistDialogCheckbox
      const isOn = Array.isArray(auto) && auto.indexOf('autoCapitalize') !== -1
      if (!isOn) return
      const current = this.$store.getters.getWorksTitleAssistDialogDetailsTitleAssistDraft
      if (current) {
        const transformed = this.toUpperAll(current)
        if (transformed !== current) {
          this.$store.commit('setWorksTitleAssistDialogDetailsTitleAssistDraft', transformed)
        }
      }
    },
    onAutoCapChange() {
      // When toggled on, immediately reformat existing draft
      const auto = this.$store.getters.getWorksTitleAssistDialogCheckbox
      const isOn = Array.isArray(auto) && auto.indexOf('autoCapitalize') !== -1
      if (isOn) {
        const current = this.$store.getters.getWorksTitleAssistDialogDetailsTitleAssistDraft
        if (current) this.$store.commit('setWorksTitleAssistDialogDetailsTitleAssistDraft', this.toUpperAll(current))
      }
    },
    resetTitleAssistState() {
      this.$store.commit('setWorksTitleAssistSuggestions', { literal: [], romaji: '', transcreation: [] })
      this.$store.commit('setWorksTitleAssistDialogDetails', { titleAssistDraft: '', titleAssistSelection: null })
      this.$store.commit('setWorksTitleAssistDialogCheckbox', ['autoCapitalize'])
      this.$store.commit('setWorksTitleAssistLoading', false)
    }
  }
}
</script>

<style scoped>
</style>


